import { Badge } from '@/components/ui/badge';

export function UpcomingBadge() {
  return (
    <Badge
      variant="outline"
      className="h-auto px-1.5 py-0.5 text-4xs font-semibold uppercase tracking-wider text-muted-foreground"
    >
      Upcoming
    </Badge>
  );
}
